/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Updated_At1Inputs */

const vi_cmspost_updated_at1 = /** @type {(inputs: Cmspost_Updated_At1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa lần cuối`)
};

/**

* @param {Cmspost_Updated_At1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_updated_at1 = /** @type {((inputs?: Cmspost_Updated_At1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Updated_At1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_updated_at1(inputs)
});
export { cmspost_updated_at1 as "cmsPost_updated_at" }